// extracted by mini-css-extract-plugin
module.exports = {"container":"notification_watcher_query-module__container--jv1es","new":"notification_watcher_query-module__new--1z4Ah"};